<template>
  <div class="py-6 px-8">
    <h-header>
      <template v-slot:actions>
        <v-btn
          v-if="isHausefulRoute"
          @click="callGenerateReport"
          :loading="loading"
          color="primary"
          elevation="0"
        >
          <v-icon left>mdi-arrow-down-bold-box-outline</v-icon>
          <span class="d-none d-md-flex body-2">
            {{ $t('hausefulInvoices.exportToExcel') }}
          </span>
        </v-btn>
        <v-menu v-if="isHostPendingRoute" offset-y offset-x>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-on="on"
              v-bind="attrs"
              :loading="loading"
              color="primary"
              elevation="0"
            >
               <span class="d-none d-md-flex body-2">
                {{ $t('hausefulInvoices.exportToExcel') }}
              </span>
              <v-icon right>mdi-chevron-down</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="callGenerateReport">
              <v-list-item-title>
                {{ $t('hausefulInvoices.withDateLimit', { date: selectedDate }) }}
              </v-list-item-title>
            </v-list-item>
            <v-list-item @click="callGenerateReportWithoutDateLimit">
              <v-list-item-title>
                {{ $t('hausefulInvoices.withoutDateLimit') }}
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </h-header>
    <router-view ref="view" />
  </div>
</template>

<script>
import {
  generateReport,
  generateHostPendingInvoicesReport,
  generateHostPendingInvoicesReportWithoutDateLimit
} from '@/views/invoices/hauseful/invoiceService'

import moment from 'moment-timezone'

export default {
  name: 'Invoices',

  methods: {
    callGenerateReport() {
      this.loading = true

      if (this.isHostPendingRoute) {
        generateHostPendingInvoicesReport({
          startDate: this.$store?.getters?.filters?.startDate,
          endDate: this.$store?.getters?.filters?.endDate,
        })
          .then((response) => this.generateExcel(response))
          .catch((error) => this.$store.commit('setToasterMessage', error.message))
          .finally(() => (this.loading = false))
      } else {
        generateReport({
          startDate: this.$store?.getters?.filters?.startDate,
          endDate: this.$store?.getters?.filters?.endDate,
        })
          .then((response) => this.generateExcel(response))
          .catch((error) => this.$store.commit('setToasterMessage', error.message))
          .finally(() => (this.loading = false))
      }
    },

    callGenerateReportWithoutDateLimit() {
      this.loading = true

      generateHostPendingInvoicesReportWithoutDateLimit()
        .then((response) => this.generateExcel(response))
        .catch((error) => this.$store.commit('setToasterMessage', error.message))
        .finally(() => (this.loading = false))
    },

    generateExcel(response) {
      let blob = new Blob([response.data], {
        type: 'application/vnd.ms-excel;charset=utf-8',
      }),
        url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'relatorio_de_notas_fiscais_hauseful.xlsx')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
    },
  },

  computed: {
    isHausefulRoute() {
      return this.$route.path.includes('hauseful')
    },

    isHostPendingRoute() {
      return this.$route.query?.tab === 'PENDING'
    },

    selectedDate() {
      const startDate = this.$store?.getters?.filters?.startDate
      const endDate = this.$store?.getters?.filters?.endDate
      const formattedStartMonth = moment(startDate).format('DD/MM')
      const formattedEndMonth = moment(endDate).format('DD/MM')
      const to = this.$t('filters.date.to')

        return `${formattedStartMonth} ${ to } ${formattedEndMonth}`
    },
  },

  data() {
    return {
      loading: false,
    }
  }
}
</script>
